import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tipo-metodo-pago-lista',
  templateUrl: './lista.component.html'
})

export class ListaComponent{
  tamano = document.body.clientHeight;
}